module.exports = __webpack_public_path__ + "img/nav-no-code.a0b99715.svg";